<template>
  <div class="goods-manage">
    <el-form
      label-position="left"
      :inline="true"
      :model="goodsManageForm"
      class="demo-form-inline"
      v-if="!showbasic"
    >
      <el-form-item label="锐锢编码">
        <el-input
          v-model.trim="goodsManageForm.ruigu_code"
          placeholder="锐锢编码"
          @keyup.enter.native="searchGoodsList"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品编码">
        <el-input
          v-model.trim="goodsManageForm.self_code"
          placeholder="商品编码"
          @keyup.enter.native="searchGoodsList"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input
          v-model="goodsManageForm.name"
          placeholder="商品名称"
          @keyup.enter.native="searchGoodsList"
        ></el-input>
      </el-form-item>
      <el-form-item label="分类">
        <el-input
          v-model="goodsManageForm.category"
          placeholder="分类"
          @keyup.enter.native="searchGoodsList"
        ></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-input
          v-model="goodsManageForm.brand"
          placeholder="品牌"
          @keyup.enter.native="searchGoodsList"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="goodsManageForm.is_enable" clearable placeholder="状态">
          <el-option label="停用" value="0"></el-option>
          <el-option label="启用" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="small"
          @click="searchGoodsList"
        >查询</el-button>
        <el-button
          type="primary"
          size="small"
          @click="onSubmitExprot"
        >导出</el-button>
        <!-- <el-button
          type="primary"
          @click="onSubmit"
        >新建</el-button> -->
      </el-form-item>
    </el-form>
    <div class="enable_btn" v-show="!showbasic">
      <el-button type="primary" size="small" @click="batchEnable('1')">启用</el-button>
      <el-button type="primary" size="small" @click="batchEnable('0')">停用</el-button>
    </div>
    <manage-table
      v-loading="manageTableLoading"
      @editGoods="editGoods"
      @getSelectGoods="getSelectGoods"
      :TableData="TableData"
      :type="type"
      v-if="!showbasic"
      @update="getGoodsList"
    ></manage-table>
    <i class="el-icon-back" v-if="showbasic" @click="backManage">返回</i>
    <manage-tab v-if="showbasic"></manage-tab>
    <el-pagination
      v-if="!showbasic"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount">
    </el-pagination>
  </div>
</template>
<script>
import manageTable from '@/components/basic/basic-table.vue'
import manageTab from '@/components/basic/goodsmanage/manage-tab.vue'
import { getGoodsList, editGoods, batchEnable, exportGoodsManage } from '@/models/goodsModel'
export default {
  name: 'goodsManage',
  components: { manageTable, manageTab },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      goodsManageForm: {
        ruigu_code: '',
        self_code: '',
        name: '',
        category: '',
        brand: '',
        is_enable: ''
      },
      TableData: [],
      type: 'manage',
      showbasic: false,
      manageTableLoading: true,
      pagesize: 10,
      currentPage: 1,
      totalCount: 0,
      selectGoodsData: []
    }
  },
  mounted () {
    this.getGoodsList()
  },
  methods: {
    async getSelectGoods (val) {
      this.selectGoodsData = val
    },
    async batchEnable (type) {
      let ids = ''
      if (this.selectGoodsData && this.selectGoodsData.length !== 0) {
        for (let i of this.selectGoodsData) {
          if (ids !== '') {
            ids = ids + ',' + i.id
          } else {
            ids = i.id
          }
        }
        let params = {
          ids: ids,
          type: type
        }
        let data = await batchEnable(params)
        if (data.message === 'Success' && type === '1') {
          this.$message.success('启用成功')
          this.getGoodsList()
        } else if (data.message === 'Success' && type === '0') {
          this.$message.success('停用成功')
          this.getGoodsList()
        }
      } else {
        this.$message.warning('未勾选列表')
      }
    },
    backManage () {
      this.showbasic = false
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.getGoodsList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getGoodsList()
    },
    changeCategoryData (data) {
      for (let i of data) {
        if (i.children) {
          if (i.children.length === 0) {
            i.children = ''
          } else {
            this.changeCategoryData(i.children)
          }
        }
      }
      return data
    },
    searchGoodsList () {
      this.currentPage = 1
      this.getGoodsList()
    },
    async getGoodsList () {
      this.manageTableLoading = true
      let params = {
        name: this.goodsManageForm.name,
        ruigu_code: this.goodsManageForm.ruigu_code,
        self_code: this.goodsManageForm.self_code,
        c_name: this.goodsManageForm.category,
        b_name: this.goodsManageForm.brand,
        page: this.currentPage,
        pagesize: this.pagesize
      }
      if (this.goodsManageForm.is_enable !== '') {
        params.is_enable = this.goodsManageForm.is_enable
      }
      let data = await getGoodsList(params)
      this.totalCount = data.total
      for (let i of data.list) {
        i.is_sale = i.is_online === 1 ? '是' : '否'
        if (i.is_enable === '0') {
          i.is_enable = '停用'
        } else {
          i.is_enable = '启用'
        }
      }
      this.TableData = data.list
      setTimeout(() => {
        this.manageTableLoading = false
      }, 300)
    },
    reload () {
      this.showbasic = false
      this.getGoodsList()
    },
    //导出
    async onSubmitExprot (){
      let params = {
        name: this.goodsManageForm.name,
        ruigu_code: this.goodsManageForm.ruigu_code,
        self_code: this.goodsManageForm.self_code,
        c_name: this.goodsManageForm.category,
        b_name: this.goodsManageForm.brand,
        page: this.currentPage,
        pagesize: this.pagesize
      }
      if (this.goodsManageForm.is_enable !== '') {
        params.is_enable = this.goodsManageForm.is_enable
      }
      await exportGoodsManage(params)
    },
    onSubmit () {

    },
    async editGoods (id) {
      let data = await editGoods(id)
      localStorage.setItem('editGoodsData', JSON.stringify(data))
      this.showbasic = true
    }
  }
}
</script>
<style lang="scss">
.goods-manage {
  .el-form {
    padding-bottom: 5px;
    border-bottom: 1px dashed #999;
  }
  .enable_btn {
    text-align: right;
  }
  .el-select,
  .el-cascader {
    width: 202px;
  }
  .el-tabs__item.is-disabled {
    cursor: not-allowed;
  }
  .el-icon-back {
    cursor: pointer;
    position: absolute;
    z-index: 1;
    right: 20px;
    top:12px;
    font-size:14px;
  }
  .el-icon-back:hover {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/basic/goodsManage.vue